import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ILocationSuggestion } from "utils/geo";

type TInput = {
  villageId: string;
  villageString: string;
  term: string;
};

type TOutput = Array<ILocationSuggestion>;

export default class StreetWhisperApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ villageId, villageString, term }: TInput): string {
    return `/fe-api/address/street-combined-whisper?term=${term}&village_id=${villageId}&village_string=${villageString}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return data.map(
      (x: any): ILocationSuggestion => ({
        id: x.id,
        label: x.label,
      }),
    );
  }
}
